const time = {
  'time.absence.KRANK_MIT_ATTEST': 'KRmA – Krank mit Attest',
  'time.absence.KRANK_OHNE_ATTEST': 'KRoA – Krank ohne Attest',
  'time.absence.FZT': 'FZT – Freizeitausgleichstag',
  'time.absence.type': 'Art',
  'time.absence.from': 'Von',
  'time.absence.to': 'Bis',
  'time.absence.workDays': 'Arbeitstage',
  'time.absence.notes': 'Bemerkung',
  'time.active': 'aktiv',
  'time.office': 'Büro',
  'time.homeOffice': 'Homeoffice',
  'time.noEntries': 'Keine Einträge',
  'time.minutes': '{n} min',

  'dashboard.title': 'Dashboard',
  'dashboard.greeting': 'Guten Tag, {name}',
  'dashboard.error': 'Fehler',
  'dashboard.workedOf': 'gearbeitet von {hours} Std.',
  'dashboard.remaining': 'Noch {hours} Std. verbleibend',
  'dashboard.targetReached': 'Sollarbeitszeit erreicht! +{hours}',
  'dashboard.checkOut': 'Ausstempeln',
  'dashboard.notCheckedIn': 'Nicht eingestempelt',
  'dashboard.today': 'Heute',
  'dashboard.since': 'Seit {time} Uhr',
  'dashboard.noEntry': 'Kein Eintrag',
  'dashboard.month': 'Monat',
  'dashboard.toMonthView': 'Zur Monatsübersicht',
  'dashboard.vacationOverview': 'Urlaubsübersicht',
  'dashboard.vacationHint': 'Details unter „Urlaub“',

  'entries.title': 'Zeiterfassung',
  'entries.loadError': 'Zeiten konnten nicht geladen werden.',
  'entries.saveError': 'Der Eintrag konnte nicht gespeichert werden.',
  'entries.confirmDelete': 'Eintrag wirklich löschen?',
  'entries.ownTimes': 'Eigene Zeiten',
  'entries.prevWeek': 'Vorherige Woche',
  'entries.currentWeek': 'Aktuelle Woche',
  'entries.nextWeek': 'Nächste Woche',
  'entries.formEdit': 'Eintrag bearbeiten',
  'entries.formAdd': 'Arbeitszeit nachtragen',
  'entries.date': 'Datum',
  'entries.start': 'Beginn',
  'entries.end': 'Ende',
  'entries.model': 'Arbeitsmodell',
  'entries.break': 'Pause (min)',
  'entries.breakAuto': 'automatisch',
  'entries.save': 'Speichern',
  'entries.add': 'Hinzufügen',
  'entries.cancel': 'Abbrechen',
  'entries.notesOptional': 'Notiz (optional)',
  'entries.weekSum': 'Wochensumme ({from} – {to})',
  'entries.daysInWeek': 'Arbeitstage in dieser Woche',
  'entries.colBreak': 'Pause',
  'entries.colWorked': 'Arbeitszeit',
  'entries.colModel': 'Modell',
  'entries.colNotes': 'Notiz',
  'entries.daySum': 'Tagessumme',

  'month.title': 'Monatsübersicht',
  'month.pdfTitle': 'Monatsbericht als PDF herunterladen',
  'month.pdfLoading': 'Wird erstellt…',
  'month.pdfFilename': 'Monatsbericht_{year}_{month}.pdf',
  'month.totalWorked': 'Gesamtarbeitszeit',
  'month.workDays': 'Arbeitstage',
  'month.avgPerDay': 'Ø pro Tag',
  'month.colDate': 'Datum',
  'month.colIn': 'Kommen',
  'month.colOut': 'Gehen',
  'month.colBreak': 'Pause',
  'month.colWorked': 'Arbeitszeit',
  'month.colLocation': 'Ort',
  'month.colNotes': 'Notiz',
  'month.homeOfficeShort': 'HO',
  'month.absencesTitle': 'Abwesenheiten in diesem Monat',

  'year.title': 'Jahresübersicht',
  'year.totalWorked': 'Gesamtarbeitszeit {year}',
  'year.days': '{n} Tage',
  'year.noEntries': 'Keine Einträge',
  'year.avgPerDay': 'Ø {time} / Tag',
  'year.absencesTitle': 'Abwesenheiten {year}',
  'year.m1': 'Jan', 'year.m2': 'Feb', 'year.m3': 'Mär', 'year.m4': 'Apr', 'year.m5': 'Mai', 'year.m6': 'Jun',
  'year.m7': 'Jul', 'year.m8': 'Aug', 'year.m9': 'Sep', 'year.m10': 'Okt', 'year.m11': 'Nov', 'year.m12': 'Dez',

  'alltime.title': 'Gesamtübersicht',
  'alltime.totalWorked': 'Gesamte Arbeitszeit',
  'alltime.daysWorked': 'Gearbeitete Tage',
  'alltime.firstEntry': 'Erster Eintrag',
  'alltime.lastEntry': 'Letzter Eintrag',
  'alltime.avgPerDay': 'Durchschnitt pro Tag:',
  'alltime.noData': 'Keine Daten vorhanden.',
};

export default time;
